module.exports = __webpack_public_path__ + "img/difusor.1ff261b9.jpg";